import React, { useContext } from "react";
import { QuizContext } from "../App";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import FormEmail from "./forms/FormEmail";
import FormPassword from "./forms/FormPassword";
import submitLogIn from "../reducer/actions/userActions/SubmitLogIn";
import Error from "../pages/Error";
import ModalForSignedUp from "./modals/ModalForSignedUp";
import ButtonCancelAndGoToPrevPage from "./buttons/ButtonCancelAndGoToPrevPage";
import ButtonLogIn from "./buttons/ButtonLogIn";
import { Card } from "react-bootstrap";
// import switchToGetOTP from "../reducer/actions/userActions/SwitchToGetOTP";

const AuthLogIn = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <div>
      {quizContext.state.errorLogIn === "500"
        ? <Error />
        : <>
          {quizContext.state.errorAuth
            && <p style={{ textAlign: "center" }}>
              <span className="error">ОШИБКА АУТЕНТИФИКАЦИИ</span><br />
              Пожалуйста, выполните вход в аккаунт ещё раз.
            </p>
          }

          <h2 className="header">
            ВОЙТИ В АККАУНТ
          </h2>

          <Form
            onSubmit={(e) => {
              e.preventDefault()
              submitLogIn(quizContext.dispatch, quizContext.state)
              quizContext.dispatch({ type: "submitLogIn" })
            }}
          >
            <Card
              data-bs-theme={theme}
              style={{
                boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
              }}
            >
              <div className={`${theme}-main-card`}>
                {quizContext.state.errorLogIn !== null
                  && quizContext.state.errorLogIn !== "500"
                  && <p className="error">
                    {quizContext.state.errorLogIn}
                  </p>
                }
                <div style={{ marginTop: "15px" }}><FormEmail /></div>
                <div style={{ margin: "20px 0" }}><FormPassword /></div>
                <div style={{ textAlign: "right" }}>
                  <Link to="/password"
                    style={{
                      textDecoration: "none",
                      color: theme === "dark"
                        ? "#4da2f7"
                        : "#0a70d6"
                    }}
                  >
                    Забыли пароль?
                  </Link>
                </div>
                <div style={{
                  textAlign: "center",
                  marginTop: "20px"
                }}
                >
                  <ButtonLogIn />
                  <ButtonCancelAndGoToPrevPage />
                </div>
              </div>
            </Card>

            <div
              style={{
                textAlign: "center",
                marginTop: "20px"
              }}>
              <p>Если у Вас <b>нет</b> аккаунта,<button
                className={`${theme}-fourth-btn`}
                onClick={() => quizContext.dispatch({ type: "switchToSignup" })}
              >
                СОЗДАТЬ АККАУНТ
              </button></p>
            </div>
          </Form>
        </>
      }

      {quizContext.state.alert === true && quizContext.state.alertStatus === "signed up"
        && <ModalForSignedUp />
      }
    </div>
  )
}

export default AuthLogIn